import { getRoleFromStorage } from "utils/auth";
const customerFormSchemaBuilder = () => {
  const role = getRoleFromStorage();
  const isAgent = role === "AGENT";
  const customerFormSchema = [
    {
      id: "id",
      dataType: "integer",
      shownOnForm: false,
      label: "ID",
      value: 0,
      isRequired: false,
      fieldType: "textfield",
    },
    {
      id: "card_number",
      dataType: "Text",
      shownOnForm: true,
      label: "Card Number",
      value: "",
      isRequired: true,
      maxChar: 60,
      fieldType: "textfield",
    },
    {
      id: "reset_pin",
      dataType: "boolean",
      shownOnForm: true,
      label: "Reset PIN (send email link)",
      value: false,
      valueMap: {
        y: true,
        n: false,
      },
      isRequired: false,
      fieldType: "checkbox",
    },
    {
      id: "owner_name",
      dataType: "Text",
      shownOnForm: true,
      label: "Customer Name",
      value: "",
      isRequired: true,
      maxChar: 120,
      fieldType: "textfield",
    },
    {
      id: "owner_phone_number",
      dataType: "Text",
      shownOnForm: true,
      label: "Phone Number",
      value: "",
      isRequired: true,
      maxChar: 30,
      fieldType: "textfield",
    },
    {
      id: "owner_patient_number",
      dataType: "Text",
      shownOnForm: true,
      label: "Patient Number",
      value: "",
      isRequired: false,
      maxChar: 60,
      fieldType: "textfield",
    },
    {
      id: "owner_email",
      dataType: "Text",
      shownOnForm: true,
      label: "Email",
      value: "",
      isRequired: false,
      maxChar: 191,
      fieldType: "textfield",
    },
  ];
  if (!isAgent) {
    customerFormSchema.push({
      id: "agent_id",
      shownOnForm: true,
      label: "Agent",
      value: null,
      isRequired: false,
      fieldType: "autocomplete",
      valueKey: "value",
      textValue: "label",
      onSearch: (query, deps) => deps.onSearchAgents(query),
      options: (deps) => deps.agents || [],
      loading: (deps) => deps.agentsLoading,
      onInputChange: (searchValue, deps) => deps.onSearchAgents?.(searchValue),
    });
  }
  return customerFormSchema;
};

export const customerFormSchema = customerFormSchemaBuilder();

export const customerRecord = {
  id: 0,
  card_number: "",
  agent_id: null,
  owner_name: "",
  owner_phone_number: "",
  owner_patient_number: "",
  owner_email: "",
};
